(function () {
  /* Recipient address autocomplete and the ZIP guard. Continues the closure
     started in twh-delivery.js via window.TWH_DELIVERY_CTX. */
  var CTX = window.TWH_DELIVERY_CTX;
  if (!CTX) return;
  var wrap = CTX.wrap, sel = CTX.sel, fields = CTX.fields;
  var ST_NAMES = {'Alabama':'AL','Alaska':'AK','Arizona':'AZ','Arkansas':'AR','California':'CA','Colorado':'CO','Connecticut':'CT','Delaware':'DE','District of Columbia':'DC','Florida':'FL','Georgia':'GA','Hawaii':'HI','Idaho':'ID','Illinois':'IL','Indiana':'IN','Iowa':'IA','Kansas':'KS','Kentucky':'KY','Louisiana':'LA','Maine':'ME','Maryland':'MD','Massachusetts':'MA','Michigan':'MI','Minnesota':'MN','Mississippi':'MS','Missouri':'MO','Montana':'MT','Nebraska':'NE','Nevada':'NV','New Hampshire':'NH','New Jersey':'NJ','New Mexico':'NM','New York':'NY','North Carolina':'NC','North Dakota':'ND','Ohio':'OH','Oklahoma':'OK','Oregon':'OR','Pennsylvania':'PA','Rhode Island':'RI','South Carolina':'SC','South Dakota':'SD','Tennessee':'TN','Texas':'TX','Utah':'UT','Vermont':'VT','Virginia':'VA','Washington':'WA','West Virginia':'WV','Wisconsin':'WI','Wyoming':'WY'};
  /* Recipient address autocomplete. Two providers:
     - With a Google Places key (twh_places_key at the top of this snippet):
       the same engine class as the checkout billing field. Fuzzy typo
       matching, house numbers, "street" + "City, ST ZIP" formatting. One
       session token spans the keystrokes and the final details call, which is
       how Google prices a whole address entry as one session.
     - Without a key: komoot Photon, free and keyless but community data with
       NO typo tolerance and patchy house numbers; fallback only.
     Either way results are US-only, the typed house number is preserved when
     the data has none, and plain typing always works, so this never blocks. */
  var GKEY = (window.TWH_DELIVERY && window.TWH_DELIVERY.gkey) || '';
  var addr = wrap.querySelector('#twh-dl-addr');
  var acWrap = wrap.querySelector('.twh-dl-addrwrap');
  var ac = document.createElement('div');
  ac.className = 'twh-dl-ac';
  ac.hidden = true;
  acWrap.appendChild(ac);
  var acT;
  function acHide() { ac.hidden = true; ac.innerHTML = ''; }
  function typedNum() {
    var m = (addr.value || '').match(/^\s*(\d+[a-zA-Z]?)\s/);
    return m ? m[1] : '';
  }
  var sessTok = null;
  function tok() {
    if (!sessTok) sessTok = Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
    return sessTok;
  }
  function fillFrom(it) {
    var num = it.num || typedNum();
    addr.value = ((num ? num + ' ' : '') + (it.street || '')).trim();
    var city = wrap.querySelector('#twh-dl-city');
    if (city && it.city) city.value = it.city;
    var zip = wrap.querySelector('#twh-dl-zip');
    if (zip && it.zip) { zip.value = it.zip; zipCheck(); }
    if (it.abbr) sel.value = it.abbr;
    acHide();
  }
  /* Google pick: one details call resolves the placeId into components, then
     the session token is retired so the next address starts a new session. */
  function pickPlace(id) {
    fetch('https://places.googleapis.com/v1/places/' + id + '?sessionToken=' + tok(), {
      headers: { 'X-Goog-Api-Key': GKEY, 'X-Goog-FieldMask': 'addressComponents' }
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        sessTok = null;
        var C = {};
        ((d && d.addressComponents) || []).forEach(function (c) {
          (c.types || []).forEach(function (t) { if (!C[t]) C[t] = c; });
        });
        function part(t, short) { return C[t] ? (short ? C[t].shortText : C[t].longText) || '' : ''; }
        fillFrom({
          num: part('street_number'),
          street: part('route'),
          city: part('locality') || part('sublocality') || part('postal_town'),
          abbr: part('administrative_area_level_1', true),
          zip: part('postal_code')
        });
      })
      .catch(acHide);
  }
  function acItem(line, rest, onPick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'twh-dl-acitem';
    b.innerHTML = '<strong></strong><span></span>';
    b.firstChild.textContent = line;
    b.lastChild.textContent = rest;
    b.addEventListener('mousedown', function (ev) { ev.preventDefault(); onPick(); });
    return b;
  }
  function acRender(items) {
    ac.innerHTML = '';
    var shown = 0;
    var keep = typedNum();
    (items || []).forEach(function (it) {
      if (it.gid) {
        if (!it.line) return;
        ac.appendChild(acItem(it.line, it.rest, function () { pickPlace(it.gid); }));
        shown++;
        return;
      }
      var num = it.num || keep;
      var line = ((num ? num + ' ' : '') + (it.street || '')).trim();
      if (!line) return;
      var rest = [it.city, [it.abbr, it.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      ac.appendChild(acItem(line, rest, function () { fillFrom(it); }));
      shown++;
    });
    ac.hidden = shown === 0;
  }
  function acQuery() {
    var q = addr.value.trim();
    if (q.length < 4) { acHide(); return; }
    var req;
    if (GKEY) {
      req = fetch('https://places.googleapis.com/v1/places:autocomplete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': GKEY },
        body: JSON.stringify({ input: q, includedRegionCodes: ['us'], sessionToken: tok() })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          return ((d && d.suggestions) || []).map(function (s) {
            var p = s.placePrediction || {};
            var sf = p.structuredFormat || {};
            return {
              gid: p.placeId || '',
              line: (sf.mainText && sf.mainText.text) || (p.text && p.text.text) || '',
              rest: (sf.secondaryText && sf.secondaryText.text) || ''
            };
          }).filter(function (it) { return it.gid; });
        });
    } else {
      req = fetch('https://photon.komoot.io/api/?limit=8&lang=en&bbox=-179.9,18.7,-66.9,71.5&q=' + encodeURIComponent(q))
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          return ((d && d.features) || []).map(function (f) { return f.properties || {}; }).filter(function (p) {
            return (p.countrycode || '').toUpperCase() === 'US';
          }).map(function (p) {
            return { num: p.housenumber || '', street: p.street || p.name || '', city: p.city || '', abbr: ST_NAMES[p.state] || '', zip: p.postcode || '' };
          });
        });
    }
    req.then(function (items) { if (document.activeElement === addr) acRender(items); }).catch(acHide);
  }
  if (addr) {
    addr.addEventListener('input', function () { clearTimeout(acT); acT = setTimeout(acQuery, 350); });
    addr.addEventListener('blur', function () { setTimeout(acHide, 150); });
  }

  /* ZIP guard. A real order was held because ZIP 30045 (Georgia) shipped with
     state NC and a misspelled city: nothing validated the pieces against each
     other. Zippopotam (free, keyless) is the authority: on a 5-digit ZIP it
     fills the official city and state, and if the buyer then picks a state that
     contradicts the ZIP, the form refuses to submit until one of them is fixed.
     If the lookup is unreachable the guard stands down and never blocks. */
  var zipEl = wrap.querySelector('#twh-dl-zip');
  var cityEl = wrap.querySelector('#twh-dl-city');
  var zipNote = document.createElement('p');
  zipNote.className = 'twh-dl-zipnote';
  zipNote.hidden = true;
  fields.appendChild(zipNote);
  var zipInfo = null; /* {abbr, city, zip} from the last successful lookup */
  function zipJudge() {
    if (!zipInfo || zipInfo.zip !== (zipEl.value.match(/^\d{5}/) || [''])[0]) {
      zipEl.setCustomValidity(''); zipNote.hidden = true; return;
    }
    if (sel.value && sel.value !== zipInfo.abbr) {
      var msg = 'ZIP ' + zipInfo.zip + ' is in ' + zipInfo.abbr + ' (' + zipInfo.city + '), not ' + sel.value + '. Fix the ZIP or the state.';
      zipEl.setCustomValidity(msg);
      zipNote.textContent = msg;
      zipNote.hidden = false;
    } else {
      zipEl.setCustomValidity(''); zipNote.hidden = true;
    }
  }
  function zipCheck() {
    var m = (zipEl.value || '').match(/^\d{5}/);
    if (!m) { zipInfo = null; zipJudge(); return; }
    fetch('https://api.zippopotam.us/us/' + m[0])
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        var pl = d && d.places && d.places[0];
        if (!pl) { zipInfo = null; zipJudge(); return; }
        zipInfo = { abbr: pl['state abbreviation'], city: pl['place name'], zip: m[0] };
        if (!sel.value) sel.value = zipInfo.abbr;
        if (cityEl && (!cityEl.value.trim() || cityEl.value.trim().toLowerCase() !== zipInfo.city.toLowerCase())) cityEl.value = zipInfo.city;
        zipJudge();
      })
      .catch(function () { zipInfo = null; zipJudge(); });
  }
  var zipT;
  if (zipEl) zipEl.addEventListener('input', function () { clearTimeout(zipT); zipT = setTimeout(zipCheck, 400); });
  sel.addEventListener('change', zipJudge);
})();
